<template>
  <input ref="toggleInput" type="checkbox" />
</template>

<script>
const events = ["change"];

export default {
  props: {
    modelValue: {
      default: null,
      required: true,
      event: "change",
      validator(value) {
        return (
          value === null ||
          typeof value === "string" ||
          typeof value === "number" ||
          typeof value === "boolean"
        );
      },
    },
    options: {
      type: [Array, Object],
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "boolean",
      validator(value) {
        return (
          typeof value === "boolean" ||
          typeof value === "string" ||
          typeof value === "number"
        );
      },
    },
    config: {
      type: Object,
      default: {
        on: "Sim",
        off: "Não",
      },
    },
  },
  data() {
    return {
      elem: null,
    };
  },
  mounted() {
    this.elem = $(this.$refs.toggleInput);
    $(this.elem).bootstrapToggle(this.config);

    if (this.modelValue) {
      $(this.elem).prop("checked", this.modelValue).change();
    }

    if (this.disabled) {
      $(this.elem).bootstrapToggle("disable");
    }

    $(this.elem).on("change", this.onChange);
    this.registerEvents();
  },
  watch: {
    /**
     * Listen to change from outside of component and update DOM
     *
     * @param newValue
     */
    modelValue(newValue) {
      $(this.elem).prop("checked", newValue).change();
    },
    disabled(newValue) {
      $(this.elem).bootstrapToggle(newValue ? "disable" : "enable");
    },
  },
  methods: {
    /**
     * Update v-model upon change triggered by date-picker itself
     *
     * @param event
     */
    onChange(event) {
      let value = $(this.elem).prop("checked");
      switch (this.mode) {
        case "string":
          value = value ? "1" : "0";
          break;
        case "number":
          value = value ? 1 : 0;
          break;
      }

      this.$emit("update:modelValue", value);
    },
    /**
     * Emit all available events
     */
    registerEvents() {
      events.forEach((name) => {
        this.elem.on(`${name}`, (...args) => {
          this.$emit(`toogle-${name}`, ...args);
        });
      });
    },
  },
};
</script>